<div *ngIf="isReactive" [formGroup]="parentForm" class="itb-checkbox">
  <mat-checkbox  [labelPosition]="position" [formControlName]="formFieldName" [checked]="isChecked"
    (change)="changeEvent($event)">
    {{label}}
  </mat-checkbox>
</div>

<div *ngIf="!isReactive" class="'itb-checkbox'">
<mat-checkbox [labelPosition]="position" [checked]="isChecked" [disabled]="isDisabled" (change)="changeEvent($event)">
  {{label}}
</mat-checkbox>
</div>